<template>
  <div :class="`iot-module${isMobile ? ' iot-module-mobile' : ''}`">
    <div class="title">
      <h1 class="tit">{{ title }}</h1>
      <h4 class="subtitle">{{ subtitle }}</h4>
    </div>
    <div class="content">
      <a href="javascript:;" class="item" v-for="(item, index) in lists" :key="index">
        <div class="img">
          <img :src="item.src" />
        </div>
        <div class="desc">
          <span v-text="item.title" />
          <span v-for="(val, i) in item.desc.split(',')" :key="i" v-text="val" />
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { _isMobile } from '@/utils/config';

export default {
  name: 'iot-module',
  // 与父组件通信
  props: {},
  // 组件
  components: {},
  // 数据
  data() {
    return {
      isMobile: _isMobile(),
      title: '小米物联模组',
      subtitle: '小米 WiFi & 蓝牙 MESH 点击查看更多型号 > ',
      lists: [
        { src: require('./resources/p00.jpeg'), title: 'MK450', desc: `[天线类型] PCB板载天线,[无线通信] SIG Mesh,[工作电压] DC3.3v,[模组尺寸] 26.75*15*4mm,[脚位间距] 2.54mm` },
        {
          src: require('./resources/p01.jpeg'),
          title: 'MK429',
          desc: '[天线类型] 需外接转接板决定天线类型,[无线通信] SIG Mesh,[工作电压] 外部转接板模块决定,[模组尺寸] 13.5*12*3mm,[脚位间距] 13.5*12*3mm',
        },
        { src: require('./resources/p02.jpeg'), title: 'MK431', desc: '[天线类型] PCB板载天线,[无线通信] SIG Mesh,[工作电压] DC3.3v,[模组尺寸] 23.5*13*4.5mm,[脚位间距] 外部转接板模块脚位决定' },
        { src: require('./resources/p03.jpeg'), title: 'MK432', desc: '[天线类型] IPEX天线,[无线通信] SIG Mesh,[工作电压] DC3.3v,[模组尺寸] 23.5*13*4.5mm,[脚位间距] 外部转接板模块脚位决定' },
      ],
    };
  },
  // 监听
  watch: {},
  // 挂载结束状态
  mounted() {},
  // 方法
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import './index.less';
</style>
